export const BugsnagConfig = {
	apiKey: "f8717ee01be8a9c2d926ea5b02811bf0"
}
